import React from 'react';
import './Footer.css';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import {Link} from "react-router-dom";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer id="footer" className="footer">
            <div className="footer-top">
                <div className="footer-container">
                    <div className="footer-columns">

                        <div className="footer-column">
                            <h3 className="footer-title">Контакты</h3>
                            <ul className="footer-contacts">
                                <li className="contact-item">
                                    <FaPhone className="contact-icon" />
                                    <a href="tel:+79999999999">+7 (495) 108-66-28</a>
                                </li>
                                <li className="contact-item">
                                    <FaEnvelope className="contact-icon" />
                                    <a href="mailto:info@mirskoe.ru">contact@bryanskmel.ru</a>
                                </li>
                                <li className="contact-item">
                                    <FaMapMarkerAlt className="contact-icon" />
                                    <span>Адрес: Брянская область, р-н Погарский, п.Мирские, ул.Садовая д. 1А с1</span>
                                </li>
                            </ul>
                        </div>

                        <div className="footer-column">
                            <h3 className="footer-title">Быстрый переход</h3>
                            <ul className="footer-links">
                                <li><Link to="/">Главная</Link></li>
                                <li><Link to="/aboutUs">О нас</Link></li>
                                <li><Link to="/productions">Продукция</Link></li>
                                <li><Link to="/contacts">Контакты</Link></li>
                                {/*<li><a href="/">Главная</a></li>*/}
                                {/*<li><a href="/aboutUs">О нас</a></li>*/}
                                {/*<li><a href="/productions">Продукция</a></li>*/}
                                {/*<li><a href="/contacts">Контакты</a></li>*/}
                            </ul>
                        </div>

                        <div className="footer-column">
                            <h3 className="footer-title">Правовая информация</h3>
                            <ul className="footer-links">
                                {/*<li><a href="/terms">Пользовательское соглашение</a></li>*/}
                                {/*<li><a href="/privacy">Политика конфиденциальности</a></li>*/}
                                <li><Link to="/terms">Пользовательское соглашение</Link></li>
                                <li><Link to="/privacy">Политика конфиденциальности</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="footer-container">
                    <div className="footer-bottom-content">
                        <p className="copyright">
                            © 2018 - {currentYear} ООО "АгроТрейд"
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;